let logRocketEnabled = false;

export function toggleLogRocket(enabled: boolean): void {
	logRocketEnabled = enabled;
}

export function isLogRocketEnabled(): boolean {
	return logRocketEnabled;
}
